import { useCallback, useEffect } from 'react';

export const eventListenerTypeEnum = {
    mousedown: 'mousedown',
    touchstart: 'touchstart',
};

/**
 * @see https://usehooks.com/useEventListener/
 */
export function useEventListener(eventName: string, handler: Function, element = window, options = { passive: true }) {
    const listener = useCallback(
        (event) => {
            if (typeof handler !== 'function') {
                return null;
            }
            return handler(event);
        },
        [handler]
    );

    useEffect(() => {
        if (element && element.addEventListener) {
            element.addEventListener(eventName, listener, options);
        }
        return () => {
            element.removeEventListener(eventName, listener);
        };
    }, [eventName, element, options]);
}
